<template>
  <div class="afdc-row">
    <div class="afdc-col-md-12 afdc-corridor-filters">
      <div class="afdc-row afdc-d-flex afdc-align-items-center">
        <div class="afdc-col-md-3">
          <state-filter/>
        </div>
        <div class="afdc-col-md-3">
          <find-fuel-filter/>
        </div>
        <div class="afdc-col-auto afdc-distance">
          <strong><span id="afdc-distance-msg" :class="checkCorridorDistance">{{corridorDistanceAllowed}} {{ $t('miles between stations allowed') }} </span></strong>
        </div>
      </div>
      <div class="afdc-row afdc-align-items-center afdc-toggle-corridor">
        <div class="afdc-col-md-4">
          <div class="afdc-custom-control afdc-custom-checkbox">
            <input type="checkbox" class="afdc-custom-control-input" v-model="showStations" :id="'stationShowCheck'" >
            <label class="afdc-custom-control-label" :for="'stationShowCheck'">{{ $t('Station Locations') }}</label>
          </div>
        </div>
        <div class="afdc-col-md-6">
          <div class="afdc-custom-control afdc-custom-checkbox">
            <input type="checkbox" class="afdc-custom-control-input" v-model="showCorridors" :id="'corridorCheck'" >
            <label class="afdc-custom-control-label" :for="'corridorCheck'">{{ $t('Designated Alternative Fuel Corridors') }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FindFuelFilter from '@/components/FindFuelFilter.vue';
import StateFilter from '@/components/StateFilter.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  name: 'CorridorFilters',

  components: {
    FindFuelFilter,
    StateFilter,
  },
  computed: {
    showStations: syncInputRouteQuery('show_corridor_stations'),

    showCorridors: syncInputRouteQuery('show_corridor_routes'),

    corridorDistanceAllowed() {
      return this.$store.getters.getCorridorDistanceAllowed;
    },
    checkCorridorDistance() {
      const distanceMsg = document.getElementById('afdc-distance-msg');
      if (distanceMsg) {
        distanceMsg.classList.remove('afdc-corridor-over');
      }
      const overDistance = this.$store.getters.isCorridorDistanceOverAllowed;
      if (overDistance && this.$store.getters.isNavActiveTabCorridorsSearchPresent && !this.$store.getters.getLoadingCorridorStations) {
        distanceMsg.classList.add('afdc-corridor-over');
      } return '';
    },
    corridorMapMode() {
      return this.$store.getters.getCorridorMapMode;
    },
  },
};
</script>

<style lang="scss">

.corridor-filters {
  margin-bottom: 16px;

  .form-group {
    margin-bottom: 0;
  }

  .corridor-over {
    color: #dd4733;
  }

  .toggle-corridor {
    margin-top: 15px;
  }
}
</style>
